import 'jquery'
import Vue from 'vue'
import Turbolinks from 'turbolinks'
import TurbolinksAdapter from 'vue-turbolinks'
import 'turbolinks-animate'
import ExampleComponent from './components/ExampleComponent'
import { setVH, CroustilleImage, focusDisplayHandler } from './lib'
import Header from './components/Header'
import Menu from './components/Menu'
import OrderForm from './components/OrderForm'
import InputNumber from './components/InputNumber'
import Alert from './components/Alert'
import Split from './components/Split'
import SliderProducts from './components/SliderProducts'
import ProductImages from './components/ProductImages'

Vue.use(TurbolinksAdapter)

Vue.component('example-component', ExampleComponent)

customElements.define('croustille-header', Header)
customElements.define('croustille-menu', Menu)
customElements.define('croustille-order-form', OrderForm)
customElements.define('croustille-input-number', InputNumber)
customElements.define('croustille-alert', Alert)
customElements.define('croustille-split', Split)
customElements.define('croustille-slider-products', SliderProducts)
customElements.define('croustille-product-images', ProductImages)

document.addEventListener('turbolinks:load', e => {
  // eslint-disable-next-line
  console.log('Turbolinks load')

  focusDisplayHandler()

  TurbolinksAnimate.init({
    animation: 'fadein',
    duration: '0.5s'
  })

  const app = new Vue({
    el: '#app',
    // vue-turbolinks to destroy app when turbolinks-animate animation ends
    turbolinksDestroyEvent: 'turbolinks:animation-end'
  })

  const lazyload = new CroustilleImage()
  lazyload.init()

  window.addEventListener('resize', setVH)
  setVH()
})

document.addEventListener('turbolinks:before-cache', () => {
  // eslint-disable-next-line
  console.log('Turbolinks before-cache')
  document.documentElement.classList.remove('has-dialog')
})

Turbolinks.start()
